import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import _ from "lodash";
import GameScoreResultRow from "./GameScoreResultRow";

const styles = (theme) => ({
  gridRoot: {
    flexGrow: 1,
    marginTop: 30,
  },
  paper: {
    margin: "25px 0",
    padding: "10px 5px",
  },
  smallCell: { padding: 0, textAlign: "center" },
  smallCellMark: { fontSize: 11, padding: "0 2px", textAlign: "center" },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
});

class GameScoreResult extends Component {
  state = {
    timeoutFilterNumber: -1,
    filterScoreKeyword: "",
    order: "asc",
    orderBy: "IdSport",
    gameScoreData: [],
    gameScoreDataNoFilter: [],
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }
    const sortedData = _.chain(this.state.gameScoreData)
      .clone()
      .orderBy(orderBy, order)
      .value();
    this.setState({ order, orderBy, gameScoreData: sortedData });
  };

  componentWillReceiveProps(nextProps) {
    const { gameScoreData } = nextProps;
    if (gameScoreData.length) {
      this.setState({
        gameScoreData,
        gameScoreDataNoFilter: gameScoreData,
      });
    }
  }

  createSortHandler = (property) => (event) => {
    this.handleRequestSort(event, property);
  };

  filterScoreData = (ev) => {
    clearTimeout(this.state.timeoutFilterNumber);
    const timeoutId = setTimeout(() => {
      if (this.state.filterScoreKeyword.length > 0) {
        const filteredScoreData = _.filter(
          this.state.gameScoreDataNoFilter,
          (scoreData) =>
            _.includes(
              scoreData.VisitorName.toUpperCase(),
              this.state.filterScoreKeyword.toUpperCase()
            ) ||
            _.includes(
              scoreData.HomeName.toUpperCase(),
              this.state.filterScoreKeyword.toUpperCase()
            )
        );
        this.setState({ gameScoreData: filteredScoreData });
      } else {
        this.setState({
          gameScoreData: _.clone(this.state.gameScoreDataNoFilter),
        });
      }
    }, 2000);
    this.setState({
      timeoutFilterNumber: timeoutId,
      filterScoreKeyword: ev.target.value,
    });
  };

  render() {
    const { order, orderBy, reasonVoid, classes } = this.props;
    return (
      <div style={{ width: "100%", minHeight: 300 }}>
        <TextField
          label="Search Team"
          className={classes.textField}
          value={this.state.filterScoreKeyword}
          onChange={this.filterScoreData}
          margin="normal"
        />
        {this.state.gameScoreData.length === 0 && (
          <Grid container spacing={8}>
            <Grid item sm>
              <Paper className={classes.paper}>
                <h3>{reasonVoid}</h3>
              </Paper>
            </Grid>
          </Grid>
        )}
        {this.state.gameScoreData.length > 0 && (
          <Grid item sm>
            <Paper className={classes.paper}>
              <h3>Score Data</h3>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="none" className={classes.smallCell}>
                      <Tooltip
                        title="Sort"
                        placement="bottom-start"
                        enterDelay={300}
                      >
                        <TableSortLabel
                          active={orderBy === "SportOrder"}
                          direction={order}
                          style={{ marginLeft: 5 }}
                          onClick={this.createSortHandler("SportOrder")}
                        >
                          Sport
                        </TableSortLabel>
                      </Tooltip>
                    </TableCell>
                    <TableCell padding="none">
                      <Tooltip
                        title="Sort"
                        placement="bottom-start"
                        enterDelay={300}
                      >
                        <TableSortLabel
                          active={orderBy === "GameDateMillis"}
                          direction={order}
                          onClick={this.createSortHandler("GameDateMillis")}
                        >
                          Game Date
                        </TableSortLabel>
                      </Tooltip>
                    </TableCell>
                    <TableCell padding="none" style={{ width: "40%" }}>
                      Visitor/Home
                    </TableCell>
                    <TableCell className={classes.smallCellMark}>
                      Game
                    </TableCell>
                    <TableCell className={classes.smallCellMark}>1H</TableCell>
                    <TableCell className={classes.smallCellMark}>2H</TableCell>
                    <TableCell className={classes.smallCellMark}>1P</TableCell>
                    <TableCell className={classes.smallCellMark}>2P</TableCell>
                    <TableCell className={classes.smallCellMark}>2P</TableCell>
                    <TableCell className={classes.smallCellMark}>4P</TableCell>
                    <TableCell className={classes.smallCell}>
                      <Tooltip
                        title="Sort"
                        placement="bottom-start"
                        enterDelay={300}
                      >
                        <TableSortLabel
                          active={orderBy === "GradedDateMillis"}
                          direction={order}
                          onClick={this.createSortHandler("GradedDateMillis")}
                        >
                          Graded
                        </TableSortLabel>
                      </Tooltip>
                    </TableCell>
                    <TableCell padding="none">Closing Line</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.gameScoreData.map((scoreRow, index) => (
                    <GameScoreResultRow
                      key={`${scoreRow.IdGame}${scoreRow.GVisitorScore}${scoreRow.GHomeScore}`}
                      scoreRow={scoreRow}
                      index={index}
                    />
                  ))}
                </TableBody>
              </Table>
            </Paper>
          </Grid>
        )}
      </div>
    );
  }
}

GameScoreResult.propTypes = {
  gameScoreData: PropTypes.array.isRequired,
  reasonVoid: PropTypes.string.isRequired,
};

export default withStyles(styles, { withTheme: true })(GameScoreResult);
